module.exports = __webpack_public_path__ + "img/dod.0d7992ac.svg";